import { useNavigate } from "react-router-dom";
import BankImage from "./bank2.jpg";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundImage: `url(${BankImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        paddingTop: "50px",
      }}
    >
      <div className="container text-center" style={{ color: "white" }}>
        {/* Bank Title  */}
        <h3
          style={{
            fontSize: "3rem",
            fontWeight: "bold",
            textShadow: "2px 2px 4px #000",
          }}
        >
          Royal Digital Bank
        </h3>

        {/* Welcome Message  */}
        <div
          className="mt-4 p-4"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            borderRadius: "15px",
            display: "inline-block",
          }}
        >
          <h5 style={{ fontSize: "1.5rem" }}>Welcome to your Financial Home</h5>
          <p style={{ fontSize: "1.1rem" }}>
            Securely manage your deposits, withdrawals, and account data in one
            place.
          </p>

          {/* Button to go to Create Account */}
          <button
            className="btn btn-primary btn-lg mt-3 shadow"
            onClick={() => navigate("/create")}
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
}
